export const NotificationRoute = {
  NOTIFICATIONS: { name: 'notifications', path: 'notifications' }
};
